import { motion } from "framer-motion";

const steps = [
    {
        n: "01",
        title: "Rotayı gir",
        desc: "Başlangıç ve varış noktasını seç. Birden fazla durak eklemek de mümkün.",
    },
    {
        n: "02",
        title: "Maliyeti gör",
        desc: "Süre, mesafe, yakıt ve HGS — toplam maliyet tek kartta özetleniyor.",
    },
    {
        n: "03",
        title: "Molanı seç",
        desc: "Güzergâhtaki restoran, mescit, tuvalet, oto yıkama yerlerini filtrele ve yola çık.",
    },
];

export default function HowItWorks() {
    return (
        <section
            id="nasil"
            data-testid="how-section"
            className="relative py-28 sm:py-36 px-5 sm:px-8 max-w-7xl mx-auto"
        >
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ duration: 0.7 }}
                className="max-w-2xl mb-16"
            >
                <div className="text-[#00F0FF] text-xs uppercase tracking-[0.22em] font-medium mb-5">
                    Nasıl çalışır?
                </div>
                <h2 className="font-display font-semibold text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
                    Üç adımda <span className="grad-text">yola çık.</span>
                </h2>
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 relative">
                {/* Connecting line (desktop) */}
                <div
                    className="hidden md:block absolute top-16 left-[12%] right-[12%] h-px bg-gradient-to-r from-[#00F0FF]/10 via-[#00F0FF]/60 to-[#FF2D92]/50"
                    aria-hidden="true"
                />

                {steps.map((s, i) => (
                    <motion.div
                        key={i}
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.3 }}
                        transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
                        className="relative p-7 rounded-2xl bg-[#111115] border border-white/[0.06]"
                    >
                        <div className="relative z-10 w-14 h-14 rounded-full bg-[#0a0a0c] border border-[#00F0FF]/40 flex items-center justify-center font-display font-semibold text-[#00F0FF]">
                            {s.n}
                        </div>
                        <h3 className="mt-5 font-display font-semibold text-xl tracking-tight">
                            {s.title}
                        </h3>
                        <p className="mt-2 text-sm text-white/55 leading-relaxed">
                            {s.desc}
                        </p>
                    </motion.div>
                ))}
            </div>
        </section>
    );
}
